import type { EbookStudyRecord } from '@wx-weiqi/contracts';

export const studyStatus: Record<EbookStudyRecord['status'], string> = {
  CONTINUE: '作答中',
  CORRECT: '正确',
  INCORRECT: '错误',
  UNKNOWN: '待判断',
  PENDING_REVIEW: '待批改',
};
export function studyDuration(ms: number | null) {
  if (ms === null) return '未记录';
  if (ms < 1000) return '不足 1 秒';
  const seconds = Math.floor(ms / 1000);
  return seconds < 60 ? `${seconds} 秒` : `${Math.floor(seconds / 60)} 分 ${seconds % 60} 秒`;
}
export function studyTime(value: string | null) {
  return value ? new Date(value).toLocaleString('zh-CN', { hour12: false }) : '未记录';
}
export function StudyResult({ status }: { status: EbookStudyRecord['status'] }) {
  return (
    <span className="ebook-study-result" data-status={status}>
      {studyStatus[status]}
    </span>
  );
}
